import { render, staticRenderFns } from "./ForBusinessPage.vue?vue&type=template&id=45eb6941&scoped=true&"
import script from "./ForBusinessPage.vue?vue&type=script&lang=js&"
export * from "./ForBusinessPage.vue?vue&type=script&lang=js&"
import style0 from "./ForBusinessPage.vue?vue&type=style&index=0&id=45eb6941&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb6941",
  null
  
)

export default component.exports